import { useId } from 'react'
import { Image } from 'react-bootstrap'
import Carousel from 'react-multi-carousel'
import LeftIcon from '@assets/icons/carousel-arrow-left.svg'
import RightIcon from '@assets/icons/carousel-arrow-right.svg'

import QuoteFull3 from '@atk/components/quote/QuoteFull3/QuoteFull3'

import styles from './PeopleStories.module.scss'

export type Carousel1ResSizeBreakpointProps = {
    max: number
    min: number
}

export type Carousel1ResSizeProps = {
    breakpoint: Carousel1ResSizeBreakpointProps
    items: number
}

export type Carousel1ResProps = {
    superLargeDesktop: Carousel1ResSizeProps
    desktop: Carousel1ResSizeProps
    tablet: Carousel1ResSizeProps
    mobile: Carousel1ResSizeProps
    [key: string]: Carousel1ResSizeProps
}

const responsive: Carousel1ResProps = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 1200 },
        items: 2,
    },
    desktop: {
        breakpoint: { max: 1199.99, min: 992 },
        items: 2,
    },
    tablet: {
        breakpoint: { max: 991.99, min: 768 },
        items: 1,
    },
    mobile: {
        breakpoint: { max: 767.99, min: 0 },
        items: 1,
    },
}

const ButtonGroup = ({
    next,
    previous,
    length,
    ...rest
}: {
    next?: () => void
    previous?: () => void
    length: number
}) => {
    const {
        carouselState: { currentSlide, deviceType },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } = rest as any
    return (
        <div className={styles.carouselButtonGroup}>
            {' '}
            <Image
                src={LeftIcon.src}
                alt="left arrow"
                className={(currentSlide === 0 ? styles.carouselDisabled : styles.carouselArrow, 'arrow-left')}
                onClick={() => previous && previous()}
            />
            <Image
                src={RightIcon.src}
                alt="right arrow"
                className={
                    (currentSlide + responsive[deviceType].items === length
                        ? styles.carouselDisabled
                        : styles.carouselArrow,
                    'arrow-right')
                }
                onClick={() => next && next()}
            />
        </div>
    )
}

export type Carousel1Props = {
    quote: string
    author: string
    authorImg: string
}

export default function PeopleStories({ list }: { list: Carousel1Props[] }) {
    const key = useId()
    return (
        <div className="peopleStories position-relative">
            <Carousel
                responsive={responsive}
                arrows={false}
                infinite
                renderButtonGroupOutside={true}
                customButtonGroup={<ButtonGroup length={list.length} />}
            >
                {list &&
                    list.map((item: Carousel1Props, index: number) => (
                        <div className="m-5 m-md-5 m-lg-3" key={key + index}>
                            <QuoteFull3 authorImage={item.authorImg} author={item.author} quote={item.quote} />
                        </div>
                    ))}
            </Carousel>
        </div>
    )
}
